import { render, staticRenderFns } from "./EmployeContratList.vue?vue&type=template&id=81b822d4"
import script from "./EmployeContratList.vue?vue&type=script&lang=ts"
export * from "./EmployeContratList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports